module.exports = __webpack_public_path__ + "static/img/成一-陳晉華.3a84cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成一-陳晉華.jpg
// module id = S/n7
// module chunks = 1